import { BannerAction, BannerLocation } from '../ActionApi/UserActionRequestModel';

export enum ApplicationClientIdentifier {
	PHOENIX = 'phoenix',
	TRAPP = 'trapp',
	IOS_APP = 'ios-app',
}

export interface EventBannerReportData {
	date: string;
	action: BannerAction;
	count: number;
	eventId: string;
	eventName: string;
	groupId?: string;
	groupName?: string;
	clientIdentifier: ApplicationClientIdentifier;
	location: BannerLocation;
}
